import { IRouteResolver } from './types';
import { TransactionScreenshotRouteResolver } from './resolvers/transaction-screenshot-route-resolver';
import { DashboardTransactionScreenshotRouteResolver } from './resolvers/dashboard-transaction-screenshot-route-resolver';
import { UserValidationRouteResolver } from './resolvers/user-validation-route-resolver';
import { DashboardValidationsRouteResolver } from './resolvers/dashboard-validations-route-resolver';
import { TransactionInstructionsRouteResolver } from './resolvers/transaction-instructions-route-resolver';
import { DashboardTransactionInstructionsRouteResolver } from './resolvers/dashboard-transaction-instructions-route-resolver';

export const resolvers: Array<() => IRouteResolver> = [
    () => new TransactionScreenshotRouteResolver(),
    () => new UserValidationRouteResolver(),
    () => new DashboardValidationsRouteResolver(),
    () => new TransactionInstructionsRouteResolver(),
    () => new DashboardTransactionInstructionsRouteResolver(),
    () => new DashboardTransactionScreenshotRouteResolver()
];
